import type { MatrixClient } from 'matrix-js-sdk';
import { useEffect, useState } from 'react';
import { ensureMatrixClient, useMatrixState } from './client.js';

/** Liga o mensageiro ao entrar na tela e devolve o cliente quando ele estiver pronto. */
export function useMatrixClient(): {
  client: MatrixClient | null;
  status: ReturnType<typeof useMatrixState>['status'];
  error: string;
  /** Pronto, mas sem rede no momento: o que for enviado sai quando voltar. */
  offline: boolean;
} {
  const state = useMatrixState();
  const [client, setClient] = useState<MatrixClient | null>(null);

  useEffect(() => {
    let cancelled = false;
    void ensureMatrixClient().then((next) => {
      if (!cancelled) setClient(next);
    });
    return () => {
      cancelled = true;
    };
  }, [state.status === 'idle']);

  return {
    client: state.status === 'ready' ? client : null,
    status: state.status,
    error: state.error,
    offline: state.offline,
  };
}
